// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>

<section class="box content" ng-if="\$ctrl.termDeposit">
  <sub-header header="\$ctrl.memoMode === 'CREDIT' ? 'Credit memo to account' : 'Debit memo to account'"></sub-header>

  <form-section>

    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">
            {{\$ctrl.termDeposit.productDefinition.productName}}
          </span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value"
              ng-class="{'currency--positive': \$ctrl.termDeposit.balance > 0, 'currency--negative': \$ctrl.termDeposit.balance < 0}">
            {{\$ctrl.termDeposit.balance | nxCurrency}}
          </span>
      </div>
      <div class="info-detail">
        <span class="key">Product branch:</span>
        <span class="value">
            {{\$ctrl.termDeposit.branch.name}}
          </span>
      </div>
      <div class="info-detail">
        <span class="key">Product number:</span>
        <span class="value">
            {{\$ctrl.termDeposit.productNumber}}
          </span>
      </div>
    </div>

    <form name="\$ctrl.memoForm">
      <deposit-memo-form
        memo-mode="\$ctrl.memoMode"
        memo-type="\$ctrl.memoType"
        category="\$ctrl.category"
        category-units="\$ctrl.categoryUnits"
        remarks="\$ctrl.remarks"></deposit-memo-form>

      <div class="summary-actions">
        <button
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          ng-if="\$ctrl.memoMode === 'CREDIT'"
          class="btn btn-success"
          ng-click="\$ctrl.doOperation()"
          ng-disabled="!\$ctrl.memoForm.\$valid">
          Credit
        </button>
        <button
          ng-if="\$ctrl.memoMode === 'DEBIT'"
          class="btn btn-danger"
          ng-click="\$ctrl.doOperation()"
          ng-disabled="!\$ctrl.memoForm.\$valid">
          Debit
        </button>
      </div>
    </form>
  </form-section>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/deposit-memo/deposit-memo.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;